export default __webpack_public_path__ + "static/media/customer-3-min.cd34e2bf.png";